import styles from "./styles.module.scss";

function LikeDebitCard() {
  return (
    <section className={styles["like-a-debit-card-section"]}>
      <h2 className={`${styles["like-debit-card-title"]} text:heading-2`}>
        The Kikoff Secured Credit Card is a secured credit card that works like
        a debit card and checking account
      </h2>
      <h4 className={`${styles["never-worry"]} text:heading-4`}>
        Never worry about overspending or due dates
      </h4>
    </section>
  );
}

export default LikeDebitCard;
